module.exports = __webpack_public_path__ + "static/media/jordan.ee5606b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jordan.jpg
// module id = 95
// module chunks = 0